export const environment = {
  production: false,
  idleTimeOutDuration: 1800,
  idleTimeOutCountDown: 30,
  authServiceUrl: 'https://hub-keycloak.demo.irembolabs.com',
  authRealm: 'irembo',
  authClientId: 'integration-management-portal',
  authSuccessRedirectUrl: 'https://integration-portal.demo.irembolabs.com',
  apiGatewayBaseUrl: 'https://integration-gateway.demo.irembolabs.com',
  automationWorkflowId: '',
  customphoneValidationRegex: /^07[2-9][0-9]{7}$/,
  AESEncryptionKey: 'encryptionKey',
  isMetabaseDashboardReportsEnabled: true,
};
